module.exports = __webpack_public_path__ + "img/fiaMobileApp.ecd8c7b8.png";